import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../analytics/ga4'

export default function AnalyticsRouteTracker() {
  const location = useLocation()

  useEffect(() => {
    const timer = window.setTimeout(() => trackPageView(location), 0)
    return () => window.clearTimeout(timer)
  }, [location.pathname, location.search])

  return null
}
